import { queryBuilds } from '@/features/builds/data';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { BuildDto, QueryResult } from '@flowqa/shared';

export const fetchBuildsGrid = async (
  projectId?: string | null,
  organisationId?: string | null,
  input?: GridQueryInput,
): Promise<QueryResult<BuildDto>> => {
  return await queryBuilds(projectId ?? undefined, organisationId ?? undefined, input);
};
